import { useNavigate } from 'react-router-dom';
import { useAppStore } from '../store/appStore';
import { getMessageById, formatMessageId, getDirectionLabel, getMessageTypeLabel } from '../utils/secsDataLoader';

export default function RecentlyViewed() {
  const navigate = useNavigate();
  const { recentlyViewed } = useAppStore();

  const recentMessages = recentlyViewed
    .map(id => getMessageById(id))
    .filter(msg => msg !== null);

  return (
    <div className="max-w-5xl mx-auto p-6">
      <div className="mb-6">
        <h1 className="text-3xl font-bold mb-2">Recently Viewed</h1>
        <p className="text-[var(--color-text-secondary)]">
          {recentMessages.length > 0
            ? `Your ${recentMessages.length} most recently viewed message${recentMessages.length !== 1 ? 's' : ''}`
            : 'No recently viewed messages'}
        </p>
      </div>

      {recentMessages.length > 0 ? (
        <div className="space-y-4">
          {recentMessages.map((message, index) => {
            if (!message) return null;

            const messageId = formatMessageId(message.stream, message.function);
            const direction = getDirectionLabel(message.direction);
            const messageType = getMessageTypeLabel(message.messageType);

            return (
              <div
                key={`${messageId}-${index}`}
                className="card p-6 cursor-pointer hover:shadow-md transition-shadow"
                onClick={() => navigate(`/message/${messageId}`)}
              >
                <div className="flex items-start justify-between mb-3">
                  <div>
                    <h2 className="text-xl font-bold mb-1">
                      <span className="font-mono text-primary-600 dark:text-primary-400">
                        {messageId}
                      </span>
                      {' - '}
                      {message.name}
                    </h2>
                    <p className="text-[var(--color-text-secondary)]">
                      {message.description}
                    </p>
                  </div>
                  <div className="text-xs text-[var(--color-text-tertiary)] ml-4">
                    #{index + 1}
                  </div>
                </div>

                <div className="flex flex-wrap gap-2">
                  <span className={`badge ${messageType.color}`}>
                    {messageType.text}
                  </span>
                  <span className={`badge ${direction.color}`}>
                    {direction.text}
                  </span>
                  {message.relatedMessage && (
                    <span className="badge badge-primary">
                      {message.messageType === 'primary' ? 'Reply: ' : 'Primary: '}
                      {message.relatedMessage}
                    </span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="text-center py-12">
          <svg
            className="mx-auto w-16 h-16 text-[var(--color-text-tertiary)] mb-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          <p className="text-[var(--color-text-secondary)] mb-4">
            You haven't viewed any messages yet.
          </p>
          <p className="text-sm text-[var(--color-text-tertiary)]">
            Browse through the streams in the sidebar to get started.
          </p>
        </div>
      )}
    </div>
  );
}
